import { XMarkIcon } from '@heroicons/react/16/solid'
import { BriefcaseIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import { ActivityIndicator } from '../../../../components'
import SampleBadge from '../../../../components/sample-data/sample-badge'
import { Heading } from '../../../../components/ui/Heading'
import { isSampleCareer } from '../../../../helpers/sample-data'
import { useCareerQuery } from '../../../../hooks/useCareerQuery'

const truncateName = (name, maxLength = 15) => {
  return name.length > maxLength ? `${name.slice(0, maxLength)}...` : name
}

export default function SelectionCareerCard({ careerId, onClickClose }) {
  const { t } = useTranslation()
  const { data: career, isLoading } = useCareerQuery(careerId)

  if (isLoading) {
    return (
      <div className='flex h-[46px] w-64 flex-row items-center justify-center rounded-lg border border-softGrey bg-white px-4 py-2'>
        <ActivityIndicator className='flex justify-center' />
      </div>
    )
  }

  // Die Selektion kommt aus der URL. Ein geteilter Link oder ein Partnerwechsel
  // kann eine Stelle enthalten, die der aktive Partner nicht lesen darf.
  const title = career?.title || t('common.unavailable_career')

  return (
    <div className='flex w-64 flex-row items-center justify-between rounded-lg border border-softGrey bg-white px-4 py-2'>
      <div className='flex flex-row items-center gap-2'>
        <div
          className='flex items-center justify-center rounded-lg bg-paleBlue'
          style={{ height: 30, width: 30 }}
        >
          <BriefcaseIcon className='size-5 text-darkBlue' />
        </div>
        <Heading level={4} title={title}>
          {truncateName(title)}
        </Heading>
      </div>
      <div className='flex flex-row items-center gap-1'>
        {career && isSampleCareer(career) && <SampleBadge kind='career' />}
        <XMarkIcon
          className='size-4 cursor-pointer text-darkGrey'
          onClick={onClickClose}
        />
      </div>
    </div>
  )
}
